<template>
  <div>
    <div class="sayfahead">
      <h1>{{ SayfaAdi }}</h1>
      <el-button-group class="float-right">
        <el-button type="danger" size="small" v-if="Yetki" class="YeniBtn" @click="Harcama">
          Maaş İşle
        </el-button>
        <el-button type="success" size="small" v-if="VezneYetki" class="YeniBtn" @click="Odeme">
          Ödeme İşle
        </el-button>
        <el-button type="info" size="small" v-if="Yetki" class="YeniBtn" @click="DuzenleBtn">
          Düzenle
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <el-row :gutter="24">
        <el-col :span="20">
          <CariEkstre :data="Ekstre" v-if="Ekstre" :Yenile="Yenile"></CariEkstre>
        </el-col>
        <el-col :span="4">
          <div class="BlokSabit" style="height: 80vh !important;">
            <div class="BlokSabitKutu">
              <BilgiKutu :data="BilgiKutu"></BilgiKutu>
              <Notlar :data="Notlar"></Notlar>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <OdemeIsle v-if="OdemeIsleModal" :Bina_id="SeciliBina" :Cari_id="Personel_id"
               :OdemeIsleModal="OdemeIsleModal" @OdemeIsleModal="ModalKapat" @mNo="Makbuz($event)"></OdemeIsle>

    <MaasIsle v-if="HarcamaIsleModal" :MaasModal="HarcamaIsleModal" @MaasModal="ModalKapat"
              :Maas="Bilgi.pMaas" :Cari_id="Personel_id" :Bina_id="Bilgi.Bina_id"></MaasIsle>
  </div>
</template>

<script>

import Notlar from "../../../components/Pack/Genel/Notlar";
import BilgiKutu from "../../../components/Pack/Genel/BilgiKutu";
import FormModal from "../../../components/Pack/Muhasebe/cari/FormModal";
import OdemeIsle from "../../../components/Pack/Muhasebe/cari/OdemeIsle";
import CariEkstre from "../../../components/Pack/Muhasebe/cari/CariEkstre";
import MaasIsle from "../../../components/Pack/Muhasebe/cari/MaasIsle";

export default {
  components: {MaasIsle, CariEkstre, OdemeIsle, FormModal, BilgiKutu, Notlar},
  props: ["Personel_id"],
  data() {
    return {
      Yenile: false,
      mNo: null,
      OdemeIsleModal: false,
      HarcamaIsleModal: false,
      MakbuzDetayModal: false,
      ModalOlayi: false,
      SayfaAdi: 'Personel Detay',
      Baslik: 'Personel Detay',
      BilgiKutu: null,
      Yetki: false,
      VezneYetki: false,
      Ekstre: null,
      SeciliBina: null,
      Notlar: {
        Modul: 'Personel',
        Modul_id: this.Personel_id
      },
      Bilgi: {
        Unvan: null,
        Telefon: null,
        Mail: null,
        Adres: null,
        vNo: null,
        vDairesi: null,
        pMaas: null,
        bBilgi: {
          Adi: null,
          Iban: null
        },
      }
    }
  },
  methods: {
    Harcama() {
      if (this.SeciliBina) {
        this.HarcamaIsleModal = true
      } else {
        this.$message.error("Lütfen Bina seçimi yapınız");
      }
    },


    DuzenleBtn() {
      this.$alert('Personel ekleme/düzenleme ve silme işlemlerini Bina Bilgi Kartını Kullanınız', 'Personel Düzenleme', {
        confirmButtonText: 'Anladım',
      });
    },
    ModalKapat() {
      alert('Modal Kapat')
      this.HarcamaIsleModal = false;
      this.OdemeIsleModal = false;
      this.Yenile = true;
      this.SayfaYukle();
    },
    SayfaYukle() {

      this.ModalOlayi = false;
      this.MakbuzDetayModal = false;
      this.OdemeIsleModal = false;
      this.$store.dispatch("Get", {path: 'muhasebe/personel/d/' + this.$route.params.Personel_id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Yenile = false;
            this.Bilgi = response.Bilgi;

            this.SayfaAdi = response.Bilgi.Unvan;
            this.Notlar.Modul_id = this.Bilgi.id;
            this.BilgiKutu = {
              Baslik: 'Personel Bilgi',
              Detay: [
                {Baslik: 'Ad Soyad', Bilgi: this.Bilgi.Unvan},
                {Baslik: 'Kalan İzin', Bilgi: this.Bilgi.kIzin + ' Gün'},
                {Baslik: 'Maaş', Bilgi: this.Bilgi.pMaas},
                {Baslik: 'Maaş Günü', Bilgi: this.Bilgi.pGun + '. Gün'},
                {Baslik: 'TC Kimlik', Bilgi: this.Bilgi.vNo},
                {Baslik: 'Telefon', Bilgi: this.Bilgi.Telefon},
                {Baslik: 'Mail', Bilgi: this.Bilgi.Mail},
                {Baslik: 'Adres', Bilgi: this.Bilgi.Adres},
                {Baslik: 'Banka Adı', Bilgi: this.Bilgi.bBilgi.Adi},
                {Baslik: 'IBAN', Bilgi: this.Bilgi.bBilgi.Iban},
                {Baslik: 'SGK Sicil', Bilgi: this.Bilgi.SGK.SicilNo},
              ]
            };
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

      // CARİ EKSTRE
      this.Ekstre = {
        Bina_id: this.SeciliBina,
        Cari_id: this.$route.params.Personel_id
      };
    },
    Odeme() {
      if (this.SeciliBina) {
        this.OdemeIsleModal = true
      } else {
        this.$message.error("Lütfen Bina seçimi yapınız");
      }
    },
  },
  created() {

    this.Yetki = this.$store.getters.Yetki.muhasebe == '2' ? true : false;
    this.VezneYetki = this.$store.getters.Yetki.vezne == '2' ? true : false;
    if (this.$store.getters.BinaBilgi) {
      this.BinaBilgi = this.$store.getters.BinaBilgi;
      this.SeciliBina = this.BinaBilgi.id;
    }
    this.SayfaYukle();

  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Muhasebe/personel/Detay.vue